import { parse } from 'hub-http/helpers/params';
import { UPGRADE_POINT_LOCATIONS } from '../constants/locations';
export const parseQueryParams = queryString => {
  const queryParams = parse(queryString.replace('?', ''));
  return Object.fromEntries(Object.entries(queryParams).map(([key, value]) => {
    try {
      const parsed = Array.isArray(value) ? value.map(val => JSON.parse(val)) : JSON.parse(value);
      return [key, parsed];
    } catch (_unused) {
      return [key, value];
    }
  }));
};
export const getQueryParams = () => parseQueryParams(window.location.search);
export const getIsInterstitialPage = location => location === 'PRICING_PAGE_INTERSTITIAL' || window.location.pathname.includes('interstitial');
export const getIsUpgradePoint = location => location && UPGRADE_POINT_LOCATIONS.includes(location) || /^\/pricing\/\d+\/upgrade(\/)?/.test(window.location.pathname);
const convertProductToQueryParams = product => {
  const {
    totalQuantity,
    quantity,
    incrementalQuantity
  } = product;
  const qty = totalQuantity || quantity || 0;
  const useIncremental = incrementalQuantity !== undefined;
  if (useIncremental) {
    return `${product.productApiName}_${incrementalQuantity}_inc`;
  }
  return `${product.productApiName}_${qty}`;
};
const convertQuantityPackToQueryParams = quantityPack => {
  const {
    totalQuantity,
    incrementalQuantity,
    parentProductApiName,
    quantityName
  } = quantityPack;
  const qty = totalQuantity || 0;
  const useIncremental = incrementalQuantity !== undefined;
  if (useIncremental) {
    return `${String(quantityName)}_${parentProductApiName}_${incrementalQuantity}_inc`;
  }
  return `${String(quantityName)}_${parentProductApiName}_${qty}`;
};
export const getPurchaseRequestAsQueryParams = purchaseRequest => {
  const {
    products,
    quantityPacks
  } = purchaseRequest;
  const tempProducts = [];
  const tempPacks = [];
  products.forEach(product => {
    tempProducts.push(convertProductToQueryParams(product));
  });
  quantityPacks === null || quantityPacks === void 0 || quantityPacks.forEach(quantityPack => {
    tempPacks.push(convertQuantityPackToQueryParams(quantityPack));
  });
  return {
    products: tempProducts,
    packs: tempPacks
  };
};